import React from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import "../styles/pages/clients_page.css";

import ChevronRightIcon from "../assets/icons/chevron-right.svg";

import ClientsImage from "../assets/images/clients_image.png";

const WholesaleClientsPage = () => {
  return (
    <div className="clients-page">
      <Header />
      <nav className="page-nav">
        <a href="/" className="nav-link">
          Главная
        </a>
        <img
          src={ChevronRightIcon}
          alt="Chevron"
          className="nav-chevron-icon"
        />
        <span className="nav-link">Оптовым клиентам</span>
      </nav>
      <div className="clients-page-content">
        <div className="for-clients-section">
          <div className="clients-text-block">
            <h2 className="gradient-page-title">
              Оптовым клиентам и государственным организациям
            </h2>
            <p className="clients-paragraph">
              ОсОО «Шнос» Bishkek Petroleum - успешно развивающаяся компания, которая активно укрепляет позиции на рынке и стремится быть надежным партнером для своих клиентов.
            </p>
            <p className="clients-paragraph">
              Мы предлагаем оптовым клиентам и государственным организациям выгодные условия сотрудничества, обеспечиваем стабильные поставки топлива и индивидуальный подход к каждому.
            </p>
            <p className="clients-paragraph">
              Наша сеть АЗС постоянно расширяется, а логистика совершенствуется, чтобы вы всегда получали топливо вовремя и без лишних хлопот. Мы гарантируем прозрачность всех операций, удобные схемы расчета и гибкие условия, адаптированные под потребности вашего бизнеса.
            </p>
            <p className="clients-paragraph">
              Сотрудничество с Bishkek Petroleum — это не только надежность поставок, но и комплексная поддержка: мы помогаем оптимизировать расходы, предоставляем консультации по выбору топлива и обеспечиваем профессиональное сопровождение на каждом этапе взаимодействия.
            </p>
          </div>
          <img
            src={ClientsImage}
            alt="Stations"
            className="clients-image-block"
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default WholesaleClientsPage;
